import {Injectable} from '@angular/core';
import {AssetsApi} from '../api/assets.api';
import {AssetHealthIndex, AssetsService, StudyAsset} from '../../../interfaces/engin/assets';
import {Observable} from 'rxjs';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';

@Injectable()
export class AssetsServiceImpl extends AssetsService {
    constructor(private api: AssetsApi) {
        super();
    }

    // Study Assets
    getStudyAssetsDataSource(studyId: string): Observable<DataSource> {
        return this.api.getStudyAssetsDataSource(studyId);
    }

    searchStudyAssets(studyId: string, assetId: string): Observable<string[]> {
        return this.api.searchStudyAssets(studyId, assetId);
    }

    getStudyAsset(studyId: string, assetId: string): Observable<StudyAsset> {
        return this.api.getStudyAsset(studyId, assetId);
    }

    // Asset Details
    getAssetDetails(studyId: string, assetId: string): Observable<any> {
        return this.api.getAssetDetails(studyId, assetId);
    }

    getAssetDetailsHealthIndex(studyId: string, assetId: string): Observable<AssetHealthIndex> {
        return this.api.getAssetDetailsHealthIndex(studyId, assetId);
    }
}
